//route.js
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate, Outlet, Redirect, useHistory, useLocation, useNavigate } from "react-router-dom";
import { isAuthenticated } from "./auth";
import Header from './Header';
import HeaderBase from './HeaderBase';
import HeaderProf from './HeaderProf';
import Menu from './Menu';
import MenuProf from './MenuProf';
import MenuCliente from './MenuCliente';
import Footer from './Footer';
import AgendaGeralView from './visViewAgendaGeral';
import HomeBase from './homeBase';
import Login from './login';
import Logout from './logout';
import NovoCadastro from './cadastro';
import ResetSenha from './reset-senha';
import ServicosView from './servicos';
import RelatoriosView from './relatorios';
import AgendaCliente from './visViewAgendaCliente';
import AgendaProfissional from './visViewAgendaProfissional';
import ProdutosView from './produtos';
import CaixaView from './caixa';
import CaixaMovView from './caixamov';
import CaixaMovConsView from './caixamovcons';
import CaixaMovConsViewProf from './caixamovconsprof';
import ClientesView from './clientes';
import ProfissionalView from './profissional';
//import AgendaProfView from './visViewAgendaProf';
import { cl } from "./components/functions";
import DashboardYou from './DashboardYou';
import Perfil from './Perfil';
import IframePage from './IframePage';
import VisualizadorPDF from './VisualizadorPDF';
import DashboardAdmin from './DashboardAdmin';




const TOKEN_KEY = "KEY_APP_BGG";
global.gIdUser = 0;

function b64DecodeUnicode(str) {
  return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}

//tamanho da tela do browser
//const deskH = window.innerHeight;        
//const deskW = window.innerWidth;

// function b64EncodeUnicode(str) {
//     return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
//         return String.fromCharCode(parseInt(p1, 16))
//     }))
// }

const token = sessionStorage.getItem(TOKEN_KEY);//sessionStorage.getItem(TOKEN_KEY);
//cl("Tokennn2",token)
//if (sessionStorage.getItem(TOKEN_KEY) == "null") {
if (sessionStorage.getItem(TOKEN_KEY) == "null") {
  sessionStorage.removeItem(TOKEN_KEY); //sessionStorage.removeItem(TOKEN_KEY);
  //this.props.history.push("/");
  //} else if (sessionStorage.getItem(TOKEN_KEY)) {
} else if (sessionStorage.getItem(TOKEN_KEY)) {
  const base64Url = token.split('.')[1];
  //cl("base",base64Url);
  const decodedValue = JSON.parse(b64DecodeUnicode(base64Url));
  //console.log("decode",decodedValue);
  const novoObj = decodedValue;
  //cl("novoObj",novoObj);
  ///global.gNome = novoObj[0].nome;
  global.gTipoUser = novoObj[0].tipo;
  global.gIDProf = novoObj[0].idprof;
  global.gAvatar = novoObj[0].avatar || null;
  global.gNome = novoObj[0].nome;
  global.gEmail = novoObj[0].email;

  //cl("global.gIDProf",global.gIDProf);
  /*   global.gDoc = novoObj[0].doc;
    global.gCond = novoObj[0].cod;
    global.gNomecond = novoObj[0].nomecond;
    global.gEmail = novoObj[0].email;
    global.gIdUser = novoObj[0].id; */
  //global.gLinkBase = "http://adminrl.dyndns.org:8085";
  //cl("gnome",global.gNome);
  //cl("gTipoUser header",global.gTipoUser);
  //cl("gDoc",global.gDoc);
  //cl("gCond",global.gCond);
  //cl("gEmail",global.gEmail);
  /*   global.gListCond = '';
    global.gaListCond = [];
    for (var i in novoObj) {
      if (i > 0) {
          global.gListCond = global.gListCond + ',';
      }
      global.gListCond = global.gListCond + novoObj[i].cod;
    
      global.gaListCond[novoObj[i].cod] =
      {
          "nome": novoObj[i].nomecond,
          "bl": novoObj[i].bloco,
          "unid": novoObj[i].unidade
      };
    
    } */

}


//okkkkkkkkkkkkk
const Headerprops = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    //<Component {...props} />
    <>
      <Header />
    </>
  )} />
)

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => isAuthenticated() ? (
    //<Component {...props} />
    <div>
      <Headerprops />
      <Menu />
      <Component />
      <Footer />
    </div>
  ) : (
    <Navigate to={{ pathname: '/login', state: { from: props.location } }} />
  )} />
)

const Private = (Component) => {


  const auth = isAuthenticated();
  console.log(auth);

  return auth ? <Component /> : <Navigate to="/login" />
}

const LoginRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    //<Component {...props} />
    <div>
      <Login />
    </div>
  )} />
)

const TestHome = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    //<Component {...props} />
    <div>
      <Home />
    </div>
  )} />
)

const AgendaGeral = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    //<Component {...props} />
    <div>
      <AgendaGeralView />
    </div>
  )} />
)


const klinkbase = sessionStorage.getItem('linkbase');
global.gLinkBase = klinkbase;

function Home() {
  return (
    <>
      <HomeBase />
      <Footer />
    </>
  );
}

function HomeUni() {
  return (
    <>
      <HeaderBase />
      <HomeBase />
      <Footer />
    </>
  );
}

function HomeProf() {
  return (
    <>
      <HeaderProf />
      <MenuProf />
      <AgendaProfissional />
      <Footer />
    </>
  );
}

function HomeCliente() {
  return (
    <>
      <HeaderProf />
      <MenuCliente />
      <AgendaCliente />
      <Footer />
    </>
  );
}

function HomeServicos() {
  return (
    <>
      <Header />
      <Menu />
      <ServicosView />
      <Footer />
    </>
  );
}

function HomeRelatorios() {
  return (
    <>
      <Header />
      <Menu />
      <RelatoriosView />
      <Footer />
    </>
  );
}

function HomeBasica() {
  return (
    <>
      <Header />
      <Menu />
      <Footer />
    </>
  );
}

function HomeProdutos() {
  return (
    <>
      <Header />
      <Menu />
      <ProdutosView />
      <Footer />
    </>
  );
}

function HomeCaixa() {
  return (
    <>
      <Header />
      <Menu />
      <CaixaView />
      <Footer />
    </>
  );
}
function HomeCaixaMov() {
  return (
    <>
      <Header />
      <Menu />
      <CaixaMovView />
      <Footer />
    </>
  );
}
function HomeCaixaMovCons() {
  return (
    <>
      <Header />
      <Menu />
      <CaixaMovConsView />
      <Footer />
    </>
  );
}
function HomeCaixaMovConsProf() {
  return (
    <>
      <HeaderProf />
      <MenuProf />
      <CaixaMovConsViewProf />
      <Footer />
    </>
  );
}


function HomeClientes() {
  return (
    <>
      <Header />
      <Menu />
      <ClientesView />
      <Footer />
    </>
  );
}

function HomeProfissional() {
  return (
    <>
      <Header />
      <Menu />
      <ProfissionalView />
      <Footer />
    </>
  );
}


const RoutesExp = () => (


  <BrowserRouter>
    <Routes>
      {/*<Route path="" element={<HomeUni />} />
      <Route index element={<HomeUni />} />*/}
      <Route path="/" element={isAuthenticated()
        ? (global.gTipoUser === 'A' ? <DashboardAdmin /> : <DashboardYou />)
        : <Navigate to="/login" />} />

      <Route path="/dashboard" element={isAuthenticated()
        ? (global.gTipoUser === 'A' ? <DashboardAdmin /> : <DashboardYou />)
        : <Navigate to="/login" />} />

      <Route path="login/:idemail" element={<Login />} />
      <Route path="login/" element={<Login />} />
      <Route path="logout" element={<Logout />} />
      <Route path="cadastro" element={<NovoCadastro />} />
      <Route path="cadastro/:pedirreset" element={<NovoCadastro />} />
      <Route path="/reset-senha/:idchave/:idemail" element={<ResetSenha />} />
      <Route element={<RequireAuth />}>
        <Route path="/dashboard-admin" element={(global.gTipoUser === 'A') ? <DashboardAdmin /> : <Navigate to="/" />} />
        <Route path="/perfil" element={<Perfil />} />
        <Route path="/iframe" element={<IframePage />} />
        <Route path="/visualizar-pdf" element={<VisualizadorPDF />} />
        {/*<Route element={<TipoUser />}>
          <Route path="agenda-geral" element={<Home />} />
          <Route path="profissional" element={<HomeProfissional />} />
          <Route path="clientes" element={<HomeClientes />} />
          <Route path="caixa" element={<HomeCaixa />} />
          <Route path="caixa-mov" element={<HomeCaixaMov />} />
          <Route path="caixa-consulta" element={<HomeCaixaMovCons />} />
          <Route path="servicos" element={<HomeServicos />} />
          <Route path="relatorios" element={<HomeRelatorios />} />
        </Route>
        <Route element={<TipoProf />}>
          <Route path="home" element={<HomeProf />} />
          {/* <Route path="prof-consulta" element={<HomeCaixaMovConsProf />} /> */}
        {/*</Route>
        <Route element={<TipoConsul />}>
          <Route path="hc" element={<HomeCliente />} />
        </Route>*/}
      </Route>
    </Routes>
  </BrowserRouter>

);

function RequireAuth() {
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const result = isAuthenticated();
      setAuth(result);
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '100px' }}>
        <img src="../assets/loading_01.gif" alt="Carregando..." />
        <p>Verificando acesso...</p>
      </div>
    );
  }

  return auth ? <Outlet /> : <Navigate to="/login" />;
}


function TipoUser() {
  //console.log("global.gTipoUser ", global.gTipoUser)

  if (global.gTipoUser === 'A') {

    return <Outlet />;
  } else
    if (global.gTipoUser === 'O') {

      return <Outlet />;
    } else
      if (global.gTipoUser === 'P') {

        return <Navigate to="/home" />;
      } else
        if (global.gTipoUser === 'C') {

          return <Navigate to="/hc" />;
        } else
          if (global.gTipoUser === '') {

            return <Navigate to="/home" />;
          } else
            if (!global.gTipoUser) {

              return <Navigate to="/home" />;
            }

  return <Navigate to="/login" />;
}
function TipoProf() {
  //console.log("global.gTipoUser ", global.gTipoUser)

  if (global.gTipoUser === 'P') {

    return <Outlet />;
  } else {
    return <Navigate to="/login" />;
  }
}

function TipoConsul() {
  //console.log("global.gTipoUser ", global.gTipoUser)

  if (global.gTipoUser === 'C') {

    return <Outlet />;
  } else {
    return <Navigate to="/login" />;
  }
}


function AuthLogin() {
  let auth = isAuthenticated();


  if (auth) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" />;
  }

  return <Outlet />;
}


export default RoutesExp;